import $i from "~/i18n";
import * as actions from "./actions";
import * as mutations from "./mutations";


var publicMenuV1 = [ 
  {
    title: $i.t("dashboardMenu.profile"),
    href: "/dashboard/profile",
    icon: "flaticon-login"
  },
  {
    title: $i.t("dashboardMenu.favorite"),
    href: "/dashboard/wish",
    icon: "flaticon-favorite"
  },
  {
    title: $i.t("dashboardMenu.mycourses"),
    href: "/dashboard/mycourses",
    icon: "flaticon-calendar-1"
  },
  {
    title: $i.t("dashboardMenu.myPayment"),
    href: "/dashboard/my-payment",
    icon: "flaticon-bill"
  },
  {
    title: $i.t("dashboardMenu.password"),
    href: "/dashboard/password",
    icon: "flaticon-login-1"
  },
  {
    title: 'درخواست تدریس',
    href: "/v1/instructor-request",
    icon: "flaticon-online"
  },
];
var publicMenu = [
  {
    title: $i.t("dashboardMenu.profile"),
    href: "/dashboard/profile",
    icon: "flaticon-login"
  },
  {
    title: $i.t("dashboardMenu.favorite"),
    href: "/dashboard/wish",
    icon: "flaticon-favorite"
  },
  {
    title: $i.t("dashboardMenu.mycourses"),
    href: "/dashboard/mycourses",
    icon: "flaticon-calendar-1"
  },
  {
    title: $i.t("dashboardMenu.myPayment"),
    href: "/dashboard/my-payment",
    icon: "flaticon-bill"
  },
  {
    title: $i.t("dashboardMenu.password"),
    href: "/dashboard/password",
    icon: "flaticon-login-1"
  }
];
var superUserMenu = [
  // {
  //   title: $i.t('dashboardMenu.myTickets'),
  //   href: '/dashboard/my-tickets',
  //   icon: 'mdi-label-outline'
  // },
  // ,   href: "/",
  //         title: "Dashboard",
  //         icon: "fa fa-user"
  {
    title: $i.t("dashboardMenu.category"),
    href: "/dashboard/category",
    icon: "flaticon-list"
  },
  {
    title: $i.t("dashboardMenu.subcategory"),
    href: "/dashboard/subcategory",
    icon: "flaticon-list-1"
  },
  {
    title: $i.t("dashboardMenu.tag"),
    href: "/dashboard/tag",
    icon: "flaticon-sales"
  },
  {
    title: $i.t("dashboardMenu.users"),
    href: "/dashboard/users",
    icon: "flaticon-team"
  },

  {
    title: $i.t("dashboardMenu.allcourses"),
    href: "/dashboard/allcourses",
    icon: "flaticon-online"
  },
  {
    title: 'مدرسین',
    href: "/dashboard/instructors-management",
    icon: "flaticon-training"
  },
  {
    title: $i.t("dashboardMenu.comments"),
    href: "/dashboard/comments",
    icon: "flaticon-chat"
  },
  {
    title: $i.t("dashboardMenu.discusses"),
    href: "/dashboard/discusses",
    icon: "flaticon-message"
  },
  // {
  //   title: $i.t('dashboardMenu.tickets'),
  //   href: '/dashboard/tickets',
  //   icon: 'mdi-format-float-right'
  // },
  {
    title: $i.t("dashboardMenu.offers"),
    href: "/dashboard/offers",
    icon: "flaticon-discount-1"
  },
  // {
  //   title: $i.t('dashboardMenu.abuse'),
  //   href: '/dashboard/abuse',
  //   icon: 'mdi-comment-remove-outline'
  // },

  {
    title: "تاریخچه مالی کل",
    href: "/dashboard/settlement",
    icon: "flaticon-payment-method"
  },
  {
    title: "تماس با مدرس",
    href: "/dashboard/calls",
    icon: "flaticon-phone-call"
  },
  {
    title: 'مدیریت مقالات',
    href: "/dashboard/blog/manage",
    icon: "flaticon-brochure"
  },
  // {
  //   title: $i.t('dashboardMenu.monitoring'),
  //   href: '/dashboard/monitoring',
  //   icon: 'mdi-monitor'
  // },
  // {
  //   title: $i.t('dashboardMenu.payment'),
  //   href: '/dashboard/payment',
  //   icon: 'mdi-credit-card-settings'
  // },

];
var instractorMenu = [
  {
   
    icon: "flaticon-comment",
    title: 'مقالات',
    open:false,
    child: [
      {
       
        title: 'مقاله جدید',
        href: "/dashboard/blog/add",
        icon: "flaticon-comment"
      },
      {
        title: $i.t("dashboardMenu.blogList"),
        href: "/dashboard/blog/list",
        icon: "flaticon-note"
      }
    ]
  },
  {
    title: "تدریس",
    icon: "flaticon-brochure",
    open:false,
    child: [
      {
        title: "راهنمای تدریس و مدرسین",
        href: "/dashboard/rules",
        icon: "flaticon-auction"
      },
      {
        title: $i.t("dashboardMenu.courseForm"),
        href: "/dashboard/new-course",
        icon: "flaticon-brochure"
      },
      {
        title: $i.t("dashboardMenu.instructors"),
        href: "/dashboard/instructors",
        icon: "flaticon-training"
      },
      {
        title: $i.t("dashboardMenu.sections"),
        href: "/dashboard/sections",
        icon: "flaticon-video-1"
      },
      {
        title: $i.t("dashboardMenu.goals"),
        href: "/dashboard/goals",
        icon: "flaticon-objective"
      },
      {
        title: $i.t("dashboardMenu.messages"),
        href: "/dashboard/messages",
        icon: "flaticon-conversation"
      },
      {
        title: $i.t("dashboardMenu.offercode"),
        href: "/dashboard/offercode",
        icon: "flaticon-percent"
      }
    ]
  }
];

export default {
  namespaced: true,
  state: () => ({
    menuInstructorSuperUser: [
      ...publicMenu,
      ...superUserMenu,
      ...instractorMenu
    ],
    menuSuperuser: [...publicMenu, ...superUserMenu],
    menuUser: [...publicMenu],
    menuUserV1: [...publicMenuV1],
    menuInstructor: [...publicMenu, ...instractorMenu],
    openSideDashboard: false
  }),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/sidebar/index.js